var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 1.33301C6.16184 1.33301 4.6665 2.82834 4.6665 4.66634V6.66634H3.99984C3.2645 6.66634 2.6665 7.26434 2.6665 7.99967V13.333C2.6665 14.0683 3.2645 14.6663 3.99984 14.6663H11.9998C12.7352 14.6663 13.3332 14.0683 13.3332 13.333V7.99967C13.3332 7.26434 12.7352 6.66634 11.9998 6.66634H11.3332V4.66634C11.3332 2.82834 9.83784 1.33301 7.99984 1.33301ZM11.9998 7.99967L12.0012 13.333H3.99984V7.99967H11.9998ZM5.99984 6.66634V4.66634C5.99984 3.56367 6.89717 2.66634 7.99984 2.66634C9.1025 2.66634 9.99984 3.56367 9.99984 4.66634V6.66634H5.99984Z",
    fill: "currentColor",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6e09b4e9.svg";
export { ForwardRef as ReactComponent };